import Clipboard from 'clipboard';

export function clipboardMixin() {
  return {
    copyText(text: string, container: any) {
      return new Promise((resolve, reject) => {
        const fakeElement = document.createElement('base-button');
        const clipboard = new Clipboard(fakeElement, {
          text() { return text; },
          action() { return 'copy'; },
          container: typeof container === 'object' ? container : document.body,
        });
        clipboard.on('success', e => {
          clipboard.destroy();
          resolve(e);
        });
        clipboard.on('error', e => {
          clipboard.destroy();
          reject(e);
        });
        fakeElement.click();
      });
    },
  };
}
